/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState } from 'react';
import { Spinner as NSpinner } from '@nextui-org/react';
import { getCookie } from '../utils';
import { AuthService, GeneralService } from '../services';

export const AuthContext = createContext({
  user: null,
  conversion: 0,
  currentRouter: null,
  isLogged: false,
  isLoading: false,
  login: () => {},
  logout: () => {},
  setConversion: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [conversion, setConversion] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const maybeHasSession = !!getCookie(process.env.REACT_APP_SESSION_NAME);
  const currentRouterCookie = getCookie(`${process.env.REACT_APP_SESSION_NAME}-rset`);
  const currentRouter = currentRouterCookie ? Number(atob(atob(currentRouterCookie))) : null;

  const logout = () => {
    setUser(null);
    AuthService.logout();
  }

  useEffect(() => {
    setIsLoading(true);
    if (maybeHasSession) {
      AuthService.getProfile()
        .then(res => setUser(res?.user?.user))
        .catch(error => console.log(error))
        .finally(() => setIsLoading(false));

      GeneralService.findConversion()
        .then(res => setConversion(res[0].amount))
        .catch(error => console.log(error));

    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        conversion,
        currentRouter,
        isLoading,
        isLogged: maybeHasSession || !!user,
        login: setUser,
        logout,
        setConversion,
        user,
      }}
    >
      {isLoading ? <Spinner /> : children}
    </AuthContext.Provider>
  )
}

const Spinner = () => (
  <div className="w-screen h-screen flex justify-center items-center">
    <NSpinner />
  </div>
);